module.exports = __webpack_public_path__ + "media/images/icons/flags/DK-887fa120409f495240d9ac0abd2c8b39.svg";